// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coloricon[data-v-baedfe98]{width:34px;height:34px;border-radius:3px}.color-select-row[data-v-baedfe98]{border-bottom:1px solid #000}.color-select-row[data-v-baedfe98]:last-child{border:0}.desktop-color-select-row[data-v-baedfe98]{border-bottom:1px solid #000}div:last-child>.desktop-color-select-row[data-v-baedfe98]{border:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
